import RandingStyle33 from "../../randing/RandingStyle33";

const BASE = "https://smilevent-assets.s3.ap-northeast-2.amazonaws.com/images/579";

const footerText = `시술 및 수술 결과는 개인별 상태에 따라 달라질 수 있으며,
환자의 구강ㆍ치아 조건에 따라 치료 방법과 비용이 달라질 수 있습니다.

Copyright ⓒ 퍼널스 · (주)빅크래프트
사업자등록번호 127-88-03197 · 402-88-02065`;

const imageUrls = {
  intro: `${BASE}/intro.jpg`,
  start: `${BASE}/startButton.png`,
  steps: ["02", "03", "04", "05", "06"].map((n) => `${BASE}/${n}.jpg`),
  keepGo: `${BASE}/keppgoButton.png`,
  submit: `${BASE}/submitButton.png`,
};

const imageAlts = [
  "춘천 임플란트 고민이세요? 내게 딱 맞는 임플란트 견적, 간단한 설문 제출하고 한번에 확인해보세요",
  "진행상황 0% 01 임플란트가 필요한 분은 누구인가요?",
  "진행상황 25% 02 임플란트가 필요한 부위는 어딘가요?",
  "진행상황 50% 03 대상자의 연령대는 무엇인가요?",
  "진행상황 75% 04 대상자의 성함을 입력해 주세요",
  "진행상황 100% 05 대상자의 휴대폰 번호를 입력해 주세요",
];

function Randing579({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle33
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      imageUrls={imageUrls}
      imageAlts={imageAlts}
      companyName="더봄치과의원"
      privacyCompanyName="더봄치과의원"
      privacyTrustee="(주)퍼널스, (주)빅크래프트"
      footerText={footerText}
      footerLegalColor="#5a5a5a"
    />
  );
}

export default Randing579;
